import type { Middleware } from 'redux';
import { RootState } from '../../reducers';

const i18nMiddleware: Middleware<{}, RootState> = () => (next) => (action) => {
  const result = next(action);

  // i18n now uses browser language detection automatically
  // No need to listen for user settings changes

  return result;
};

export default i18nMiddleware;
